<div class="cards-container">
  <ng-container *ngFor="let request of requests">
    <div class="animated-col d-flex" (click)="viewDetails(request.requestId, request.dictionaryCategoryTypeId)" role="button">
      <div class="request-card ccc flex-grow-1">
        <div class="category">
          <dynamic-field [props]="props?.DictionaryRequestCategoryName" [canBeEmpty]="true" class="fs-4 fw-bold">
            <div HJSuppress>{{ request.dictionaryRequestCategoryName }}</div>
          </dynamic-field>
        </div>

        <div class="request-type">
          <dynamic-field [props]="props?.DictionaryRequestTypeName" [canBeEmpty]="true" >
            <div HJSuppress class="fw-semibold">{{ request.dictionaryRequestTypeName }}</div>
          </dynamic-field>
        </div>

        <div class="date">
          <dynamic-field [props]="props?.CreatedOn" [canBeEmpty]="true">
            <div class="date-label fw-semibold">{{'request.Date' | translate}}</div>
            <span HJSuppress class="date-value fw-bold">
              {{ request.createdOn | localizedDate }}
            </span>
          </dynamic-field>
        </div>
        <div class="status-box mb-3">
          <dynamic-field [props]="props?.DictionaryRequestStatus" [canBeEmpty]="true" >
              <div class="status-content">
                  <div class="status-dot" 
                    [ngClass]="request.dictionaryRequestStatus.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                              request.dictionaryRequestStatus.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress':
                              request.dictionaryRequestStatus.code===dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                              request.dictionaryRequestStatus.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                  </div>
                  <div HJSuppress class="status-value">{{ request.dictionaryRequestStatus.value}}</div>
              </div>
           </dynamic-field>
        </div>
        <div class="status-box">
          <div HJSuppress class="status-value">{{"request.statusChange.UpdatedBy" | translate}}: {{request?.statusUpdatedByUserName}}</div>
          <div HJSuppress class="status-value">{{"request.statusChange.UpdatedOn" | translate}}: {{request?.statusUpdatedOn | localizedDate }} </div> 
        </div>
        <div>
          <dynamic-field [props]="props?.PartnerName" [canBeEmpty]="true">
            <span HJSuppress class="partner-name fw-bold">
              {{ request.partnerName }}
            </span>
          </dynamic-field>
        </div>

        <div class="user-name">
          <dynamic-field [props]="props?.UserName" [canBeEmpty]="true" >
           <div HJSuppress>
             {{ request.userName}}
           </div>
          </dynamic-field>
        </div>
      </div>
    </div>
  </ng-container>
</div>